const recs: any = {
  ui: 'recs_management:ui',
  accounts: 'recs_management:accounts',
  eligibility: 'recs_management:eligibility',
  generation: 'recs_management:generation',
  organization: 'recs_management:organization',
  transaction: 'recs_management:transaction',
};

export default recs;